import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'scrollbar-hidden flex max-md:-mx-3 max-md:w-[calc(100%+24px)] max-md:overflow-x-scroll',
    icon: 'h-4 w-auto',
    image: 'h-4 w-auto',
    tagGroup: 'shrink-0 flex-nowrap max-md:px-3 md:w-full md:flex-wrap'
  }
});
